// --- Swiper import & init ---

// Settings: https://swiperjs.com/get-started/

import Swiper from 'swiper/core';
import { Navigation, Pagination, Thumbs, Autoplay } from 'swiper/modules';

Swiper.use([
  Autoplay,
  Navigation,
  Pagination,
  Thumbs
]);

// --- Swiper settings ---

const swiperSettings = {
	//modules: [Navigation],
	loop: true,
	centeredSlides: true,
	spaceBetween: 15,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets'
	},
	breakpoints: {
		0: {
			slidesPerView: 1.5
		},
		576: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 3.5
		},
		992: {
			slidesPerView: 4,
			centeredSlides: false
		},
		1200: {
			slidesPerView: 5
		}
	}

};

const swiperSettingsHome = {
	loop: true,
	speed: 1000,
	spaceBetween: 0,
	watchSlidesProgress: true,
	autoplay: {
		delay: 6500,
		disableOnInteraction: false,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets'
	},
};

var sliderBgSetting = document.querySelectorAll('.slide-bg-image');
for(var i = 0; i < sliderBgSetting.length; i++) {
	if (sliderBgSetting[i].dataset.background) {
		sliderBgSetting[i].style.backgroundImage = "url(" + sliderBgSetting[i].dataset.background + ")";
	}
}

const swiperSettingsPartners = {
	loop: true,
	centeredSlides: false,
	spaceBetween: 10,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		0: {
			slidesPerView: 1,
			centeredSlides: true
		},
		576: {
			slidesPerView: 1,
			centeredSlides: true
		},
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3,
		},
		1200: {
			slidesPerView: 3
		}
	}
};

const swiperSettingsTimeline = {
	loop: false,
	centeredSlides: true,
	spaceBetween: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
};

const swiperSettingsKatalogArchive = {
	loop: false,
	centeredSlides: true,
	spaceBetween: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
};

const swiperSettingsKatalogDetail = {
	loop: false,
	centeredSlides: false,
	spaceBetween: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
};

const swiperSettingsKatalogPlatform = {
	loop: false,
	centeredSlides: false,
	spaceBetween: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
};

const swiperSettingsReferenceThumbs = {
	direction: 'vertical',
	//freeMode: true,
	watchSlidesProgress: true,
	watchSlidesVisibility: true,
	loop: false,
	centeredSlides: false,
	centeredSlidesBounds: true,
	watchOverflow: true,
	spaceBetween: 21,
	//autoHeight: true,
	breakpoints: {
		0: {
			direction: 'horizontal',
			slidesPerView: 3,
			spaceBetween: 10,
		},
		576: {
			direction: 'horizontal',
			slidesPerView: 3,
			spaceBetween: 10,
		},
		768: {
			direction: 'horizontal',
			slidesPerView: 4,
			spaceBetween: 10,
		},
		992: {
			slidesPerView: 3
		},
		1200: {
			slidesPerView: 4
		}
	}
};

const swiperSettingsContact = {
	loop: false,
	centeredSlides: false,
	spaceBetween: 20,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		0: {
			slidesPerView: 1.25
		},
		576: {
			slidesPerView: 1.5
		},
		768: {
			slidesPerView: 2
		},
		992: {
			slidesPerView: 3
		},
		1200: {
			slidesPerView: 4
		}
	}
};

// --- Swiper instances ---

const mountSwiper = new Swiper('.swiper-container', swiperSettings);
const mountSwiperHome = new Swiper('.swiper-home', swiperSettingsHome);
const mountSwiperPartners = new Swiper('.swiper-partners', swiperSettingsPartners);
const mountSwiperTimeline = new Swiper('.swiper-timeline', swiperSettingsTimeline);
const mountSwiperKatalogArchive = new Swiper('.swiper-katalog', swiperSettingsKatalogArchive);
const mountSwiperKatalogDetail = new Swiper('.swiper-detail', swiperSettingsKatalogDetail);
const mountSwiperKatalogPlatform = new Swiper('.swiper-platform', swiperSettingsKatalogPlatform);
const mountSwiperReferenceThumbs = new Swiper('.swiper-reference-thumbs', swiperSettingsReferenceThumbs);
const mountSwiperContact = new Swiper('.swiper-contact', swiperSettingsContact);


const swiperSettingsReference = {
	loop: false,
	centeredSlides: true,
	spaceBetween: 0,
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	thumbs: {
		swiper: mountSwiperReferenceThumbs,
	},
};

const mountSwiperReference = new Swiper('.swiper-reference', swiperSettingsReference);
